import { render, staticRenderFns } from "./ListFacturas.vue?vue&type=template&id=117758e0&"
import script from "./ListFacturas.vue?vue&type=script&lang=js&"
export * from "./ListFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports